import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {QuestionsSearch} from '../../../models/questions-search.interface';
import {Master} from '../../../../admin/models/master.interface';

@Component({
  selector: 'app-questions-filter',
  templateUrl: './questions-filter.component.html',
  styleUrls: ['./questions-filter.component.scss']
})
export class QuestionsFilterComponent implements OnInit {


  searchForm = this.formBuilder.group({
    shortCode: [''],
    description: [''],
    category: [0],
    questionType: [],
    status: ['ACTIVE']
  });

  questionTypes = [
    {value: 'COUNTRY', description: 'Country'},
    {value: 'SYSTEM', description: 'System'},
    {value: 'BOTH', description: 'Both'},
  ];

  get shortCodeControl(): FormControl {
    return this.searchForm.get('shortCode') as FormControl;
  }
  get descriptionControl(): FormControl {
    return this.searchForm.get('description') as FormControl;
  }
  get categoryControl(): FormControl {
    return this.searchForm.get('category') as FormControl;
  }
  get questionTypeControl(): FormControl {
    return this.searchForm.get('questionType') as FormControl;
  }
  get statusControl(): FormControl {
    return this.searchForm.get('status') as FormControl;
  }

  @Input()
  categories!: Master[];

  @Output()
  search: EventEmitter<QuestionsSearch> = new EventEmitter<QuestionsSearch>();

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
  }

  handleSubmit(): void {
    const dto: QuestionsSearch = {
      shortCode: this.shortCodeControl.value,
      description: this.descriptionControl.value,
      category: this.categoryControl.value,
      questionType: this.questionTypeControl.value,
      status: this.statusControl.value
    };
    this.search.emit(dto);
  }

  clean(): void {
    this.search.emit({});
  }

}
